import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      balance: {
        balance_in_site_header: 'BALANCE_IN_HEADER',
      },
    },
  }));
}

export function getSupervisionNotificationTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      supervision: {
        admin_cannot_modify_any_data: 'ADMIN_CANNOT_MODIFY_ANY_DATA',
        stop_supervision: 'STOP_SUPERVISION',
      },
    },
  }));
}
